// acquisition.js — first-touch ad-campaign capture for signup attribution.
// Reads UTM/click-id params from the landing URL once, persists them, and the
// register call sends them so the backend can group signups per ad channel.
const KEY = 'fws_acq';
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'ttclid', 'fbclid'];

export function captureAcquisition() {
  try {
    if (localStorage.getItem(KEY)) return; // first touch wins
    const qs = new URLSearchParams(window.location.search);
    const acq = {};
    PARAMS.forEach((k) => {
      const v = qs.get(k);
      if (v) acq[k] = v.slice(0, 300);
    });
    if (!Object.keys(acq).length) return;
    acq.landing_page = (window.location.pathname || '/').slice(0, 300);
    localStorage.setItem(KEY, JSON.stringify(acq));
  } catch (_e) { /* private mode / storage quota — organic it is */ }
}

export function getAcquisition() {
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (_e) { return null; }
}
